/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetInventoryDetailResponse,
  AssetInventoryListResponse,
} from '../models/index';
import {
    AssetInventoryDetailResponseFromJSON,
    AssetInventoryDetailResponseToJSON,
    AssetInventoryListResponseFromJSON,
    AssetInventoryListResponseToJSON,
} from '../models/index';

export interface MdmAssetInventoryDetailRequest {
    assetGoldenId: string;
    sessionId: string;
    assetClass?: string;
}

export interface MdmAssetInventoryListRequest {
    sessionId: string;
    page?: number;
    size?: number;
    hostnameContains?: string;
}

/**
 * AssetInventoryApi - interface
 * 
 * @export
 * @interface AssetInventoryApiInterface
 */
export interface AssetInventoryApiInterface {
    /**
     * 
     * @summary Asset inventory detail (REQ-INV-01–06)
     * @param {string} assetGoldenId 
     * @param {string} sessionId 
     * @param {string} [assetClass] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryApiInterface
     */
    mdmAssetInventoryDetailRaw(requestParameters: MdmAssetInventoryDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDetailResponse>>;

    /**
     * Asset inventory detail (REQ-INV-01–06)
     */
    mdmAssetInventoryDetail(requestParameters: MdmAssetInventoryDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDetailResponse>;

    /**
     * 
     * @summary Asset inventory list (REQ-INV-06)
     * @param {string} sessionId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [hostnameContains] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryApiInterface
     */
    mdmAssetInventoryListRaw(requestParameters: MdmAssetInventoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryListResponse>>;

    /**
     * Asset inventory list (REQ-INV-06)
     */
    mdmAssetInventoryList(requestParameters: MdmAssetInventoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryListResponse>;

}

/**
 * 
 */
export class AssetInventoryApi extends runtime.BaseAPI implements AssetInventoryApiInterface {

    /**
     * Asset inventory detail (REQ-INV-01–06)
     */
    async mdmAssetInventoryDetailRaw(requestParameters: MdmAssetInventoryDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDetailResponse>> {
        if (requestParameters['assetGoldenId'] == null) {
            throw new runtime.RequiredError(
                'assetGoldenId',
                'Required parameter "assetGoldenId" was null or undefined when calling mdmAssetInventoryDetail().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmAssetInventoryDetail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/inventory/assets/{assetGoldenId}`;
        urlPath = urlPath.replace(`{${"assetGoldenId"}}`, encodeURIComponent(String(requestParameters['assetGoldenId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDetailResponseFromJSON(jsonValue));
    }

    /**
     * Asset inventory detail (REQ-INV-01–06)
     */
    async mdmAssetInventoryDetail(requestParameters: MdmAssetInventoryDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDetailResponse> {
        const response = await this.mdmAssetInventoryDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Asset inventory list (REQ-INV-06)
     */
    async mdmAssetInventoryListRaw(requestParameters: MdmAssetInventoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmAssetInventoryList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['hostnameContains'] != null) {
            queryParameters['hostnameContains'] = requestParameters['hostnameContains'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/inventory/assets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryListResponseFromJSON(jsonValue));
    }

    /**
     * Asset inventory list (REQ-INV-06)
     */
    async mdmAssetInventoryList(requestParameters: MdmAssetInventoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryListResponse> {
        const response = await this.mdmAssetInventoryListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
